import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "saved-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-sync sync-icon" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-trash trash-icon" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "image-indicator"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-image" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Image attached ")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.codes, (code) => {
    return (_openBlock(), _createElementBlock("ul", {
      key: code.id,
      class: "left-align list"
    }, [
      _createElementVNode("li", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(code.unit), 1),
        _createElementVNode("span", null, _toDisplayString(code.codes), 1),
        (!code.id && _ctx.saving === code.unit)
          ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
              key: 0,
              style: {"height":"25px","width":"25px","margin-right":"5px"}
            }))
          : (!code.id)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: ($event: any) => (_ctx.onSyncCode(code)),
                class: _normalizeClass(`small-btn ${_ctx.syncing === code.unit ? 'spin' : ''}`)
              }, _hoisted_4, 10, _hoisted_2))
            : (_openBlock(), _createElementBlock("button", {
                key: 2,
                onClick: ($event: any) => (_ctx.onDeleteCode(code)),
                class: "small-btn"
              }, _hoisted_7, 8, _hoisted_5))
      ]),
      (code.imageData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
        : _createCommentVNode("", true),
      _createVNode(_component_Divider)
    ]))
  }), 128))
}